import { FC } from "react";
import "react-circular-progressbar/dist/styles.css";
import { colors } from "@ht/shared/theme/index";
import { ClipLoader, PuffLoader } from "react-spinners";
interface IProps {
    loading: boolean;
    type: "PUFF" | "CLIP";
    position?: "FULL_WINDOW" | "FULL_PARENT";
}
const Spinner: FC<IProps> = ({ loading, type, position = "FULL_WINDOW" }) => {
    const getSpinner = () => {
        if (type == "PUFF") {
            return (
                <PuffLoader
                    color={colors.primary["300"]}
                    loading={loading}
                    size={150}
                    aria-label="Loading Spinner"
                />
            );
        } else if (type == "CLIP") {
            return (
                <ClipLoader
                    color={colors.primary["300"]}
                    loading={loading}
                    size={150}
                    aria-label="Loading Spinner"
                />
            );
        }
    };
    return loading ? (
        <div className="static z-50 w-full h-full">
            {position == "FULL_WINDOW" && (
                <div className="absolute top-0 left-0 bg-white opacity-60 rounded-lg w-full h-full">
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                        {getSpinner()}
                    </div>
                </div>
            )}
            {position == "FULL_PARENT" && (
                <div className="flex items-center justify-center h-full">
                    {getSpinner()}
                </div>
            )}
        </div>
    ) : (
        <></>
    );
};

export default Spinner;
